import { createStore } from 'vuex'
import { setupAxios } from '@/services/api'

// Import modules
import auth from './modules/auth'
import llm from './modules/llm'
import llmChat from './modules/llmChat'
import agents from './modules/agents'
import knowledgeBases from './modules/knowledgeBases'
import messagingPlatforms from './modules/messagingPlatforms'
import organizations from './modules/organizations'
import users from './modules/users'
import roles from './modules/roles'
import workstreams from './modules/workstreams'
import tasks from './modules/tasks'
import chat from './modules/chat'
import governance from './modules/governance'

// Initialize axios configuration
setupAxios()

export default createStore({
  // Global state for app-wide concerns
  state: {
    // Global loading state
    isLoading: false,
    // Global error and success messages
    error: null,
    successMessage: null
  },
  
  // Global mutations
  mutations: {
    SET_LOADING(state, loading) {
      state.isLoading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    SET_SUCCESS_MESSAGE(state, message) {
      state.successMessage = message
    },
    CLEAR_MESSAGES(state) {
      state.error = null
      state.successMessage = null
    }
  },
  
  // Global actions for error/success handling
    actions: {
    showError({ commit }, error) {
      commit('SET_ERROR', error)
    },
    showSuccess({ commit }, message) {
      commit('SET_SUCCESS_MESSAGE', message)
    },
    clearMessages({ commit }) {
      commit('CLEAR_MESSAGES')
    },
    setLoading({ commit }, loading) {
      commit('SET_LOADING', loading)
    },
    handleError({ commit }, error) {
      // Handle error globally - extract message from error object
      const errorMessage = error?.response?.data?.message || error?.message || 'An error occurred'
      commit('SET_ERROR', errorMessage)
      console.error('Global error handler:', error)
    },
    // Reset all module states on logout or user switch
    resetAll({ commit }) {
      const mods = [
        'agents','knowledgeBases','messagingPlatforms','organizations','users','roles','workstreams','tasks','chat','llm','llmChat','governance'
      ]
      mods.forEach(m => {
        try { commit(`${m}/SET_ITEMS`, [], { root: true }) } catch (e) {}
        try { commit(`${m}/SET_CURRENT_ITEM`, null, { root: true }) } catch (e) {}
        try { commit(`${m}/CLEAR_ERROR`, null, { root: true }) } catch (e) {}
        try { commit(`${m}/SET_PAGINATION`, { totalCount: 0, currentPage: 1, itemsPerPage: 10 }, { root: true }) } catch (e) {}
      })
    }
  },
  
  // Global getters
  getters: {
    isLoading: state => state.isLoading,
    error: state => state.error,
    successMessage: state => state.successMessage
  },
  
  // Register modules
  modules: {
    auth,
    llm,
    llmChat,
    agents,
    knowledgeBases,
    messagingPlatforms,
    organizations,
    users,
    roles,
    workstreams,
    tasks,
    chat,
    governance
  }
})
